import { InlineHelp } from "@/components/common/InlineHelp";

export function OpsPaperworkFastfieldSection(props: {
  fastfieldLoading: boolean;
  onFastfieldSync: () => Promise<void>;
  fastfieldSubmissions: Array<{
    id: string;
    external_submission_id: string;
    deal_id: string | null;
    created_at: string;
    raw: Record<string, unknown>;
  }>;
}) {
  return (
    <div className="space-y-2">
      <InlineHelp label="How FastField evidence works">
        Webhook: <code>/api/integrations/fastfield/webhook?org_id=&lt;uuid&gt;</code> with header{" "}
        <code>X-FastField-Secret</code> or query <code>token</code> matching <code>FASTFIELD_WEBHOOK_SECRET</code>.
        Include <code>deal_id</code> or <code>order_id</code> in the JSON body for paperwork auto-receive.
      </InlineHelp>
      <button
        type="button"
        className="rounded border px-3 py-1"
        disabled={props.fastfieldLoading}
        onClick={() => void props.onFastfieldSync()}
      >
        {props.fastfieldLoading ? "Refreshing…" : "Refresh FastField ledger"}
      </button>
      {props.fastfieldSubmissions.length ? (
        <div className="overflow-x-auto rounded border border-gray-200">
          <table className="min-w-full text-xs">
            <thead className="bg-gray-50 text-left text-gray-600">
              <tr>
                <th className="px-2 py-1 font-medium">Received</th>
                <th className="px-2 py-1 font-medium">Submission</th>
                <th className="px-2 py-1 font-medium">Form</th>
                <th className="px-2 py-1 font-medium">Deal</th>
              </tr>
            </thead>
            <tbody>
              {props.fastfieldSubmissions.map((row) => {
                const formName = typeof row.raw.formName === "string" ? row.raw.formName : null;
                const formId = row.raw.formId ?? row.raw.form_id;
                return (
                  <tr key={row.id} className="border-t border-gray-100">
                    <td className="whitespace-nowrap px-2 py-1">{new Date(row.created_at).toLocaleString()}</td>
                    <td className="px-2 py-1 font-mono text-[11px]">{row.external_submission_id.slice(0, 8)}…</td>
                    <td className="px-2 py-1">{formName ?? (formId != null ? String(formId) : "—")}</td>
                    <td className="px-2 py-1 font-mono text-[11px]">
                      {row.deal_id ? `${row.deal_id.slice(0, 8)}…` : "unlinked"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-xs text-gray-500">No FastField submissions yet.</p>
      )}
    </div>
  );
}
